
import Maximize4 from "../../../assets/duotone/Maximize4.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Maximize4Icon({ className, dataTestid = "Maximize4Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Maximize4 data-testid={dataTestid} className={classes} {...rest} />
  );
}
